/**
 * Site-level constants for conscierra.au (client-portal).
 *
 * MEDIA_BASE_URL — where marketing films and their posters are served from (Story #23825).
 * Root-relative on purpose: Front Door routes `/media/*` on conscierra.au and
 * www.conscierra.au to the `media` Blob container (infra/bicep/media.bicep), so the video is
 * same-origin and the CSP needs only `media-src 'self'`. Blob Storage answers HTTP Range (206)
 * requests natively; this site's static host cannot, which is why films never go in public/.
 * Baked at build time so the prerendered <video> src matches what hydrates.
 *
 * NOTE: only conscierra.au + www are routed to the media origin. The .sg / .id / .fj domains
 * are not, so a film added here will not play on those hosts until their Front Door routes
 * exist. Today the film list is empty, so nothing is affected.
 */
export const MEDIA_BASE_URL = '/media';
